import { StyleSheet, Text, View } from "react-native";
import React from "react";
import Layout from "~components/atoms/Layout/index.web";

const CreateTask = () => {
  return (
    <Layout>
      <Text>CreateTask</Text>
    </Layout>
  );
};

export default CreateTask;

const styles = StyleSheet.create({});
